import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { frontViewDataSkeleton, sideViewDataSkeleton } from './tableSkeletons';

var populateTables = function populateTables(dimensionAttributes) {
  var updateTable = function updateTable(skeleton) {
    var _Object$keys;

    if (!dimensionAttributes || !((_Object$keys = Object.keys(dimensionAttributes)) !== null && _Object$keys !== void 0 && _Object$keys.length)) {
      return [];
    }

    var table = skeleton.map(function (tableObj) {
      var sectionId = tableObj.sectionId;
      if (!dimensionAttributes[sectionId]) return null;
      return _objectSpread(_objectSpread({}, tableObj), {}, {
        size: dimensionAttributes[sectionId].replace('cm', '')
      });
    });
    return table.filter(Boolean);
  };

  var frontViewTable = updateTable(frontViewDataSkeleton);
  var sideViewTable = updateTable(sideViewDataSkeleton);
  return [frontViewTable, sideViewTable];
};

export default populateTables;